module.exports = "/_next/static/images/b17d356f709c0f33c8e1e8e0be6eda4e-google.svg";